import type { OnboardingJourney } from '../../hooks/usePlusWebsites';

export interface OnboardingJourneyOption {
  value: OnboardingJourney;
  label: string;
}

// Order mirrors the edit dialog in the design.
export const ONBOARDING_JOURNEY_OPTIONS: OnboardingJourneyOption[] = [
  { value: 'delivery-collection', label: 'Delivery (commissionable) / Collection' },
  { value: 'pharmacy-select', label: 'Just Select Pharmacy' },
  { value: 'marketplace', label: 'Marketplace Delivery Options' },
];
